module.exports = __webpack_public_path__ + "static/media/pagina1-plant_boven_blog.01e36a9a.svg";